import { render, staticRenderFns } from "./SelectFacebookPage.vue?vue&type=template&id=fcf8a778&"
import script from "./SelectFacebookPage.vue?vue&type=script&lang=js&"
export * from "./SelectFacebookPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports